import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelity',
    label: 'Fidelity Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
